import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ProblemSection from "@/components/ProblemSection";
import SolutionSection from "@/components/SolutionSection";
import DifferentialsSection from "@/components/DifferentialsSection";
import ResultsSection from "@/components/ResultsSection";
import ImplementationSection from "@/components/ImplementationSection";
import FAQSection from "@/components/FAQSection";
import CTAMultiple from "@/components/CTAMultiple";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import OrganizationSchema from "@/components/OrganizationSchema";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Gestão de Chamados com IA para Times de Suporte"
        description="Todos os chamados de WhatsApp, e-mail, chat e formulários em uma só fila, com automações no-code e a VIA, IA da Aroan. A Eleeva IT reduziu o tempo médio de atendimento de 5h para 1h."
        canonical="https://aroan.com.br/"
        ogType="website"
        keywords="automação inteligente, plataforma unificada, IA empresarial, gestão de chamados, BPM, service desk, VIA"
        article={false}
      />
      <OrganizationSchema />
      <Header />
      <main>
        <Hero />
        <ProblemSection />
        <SolutionSection />
        <DifferentialsSection />
        <ResultsSection />
        <ImplementationSection />
        <FAQSection />
        <CTAMultiple />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
